import { SET_ALL_APPS } from '../types/allAppsConstants'

const initialState = {
  allApps: []
}

export default function allAppsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ALL_APPS:
      return {
        ...state,
        allApps: action.payload ? action.payload : []
      }

    default:
      return state
  }
}
